import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Observable, switchMap } from 'rxjs';
import { Location } from '../../../../../models/locations-models/location';
import { Store } from '@ngrx/store';
import { selectStatusViewModel } from '../../state/location-list-selectors';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';

export interface StatusCellState extends AgCellState {}

@Injectable({
  providedIn: 'root'
})
export class StatusCellLocalStoreService extends AgCellLocalStoreService<StatusCellState> {

  constructor(private store: Store, private locationListLocalStore: LocationListLocalStoreService) {
    super({
      cellValue: '',
      params: null
    })
  }

  readonly viewModel$: Observable<{
    hasBlacklistedFields: boolean,
    hasOpenDifferences: boolean,
    hasIgnoredDifferences: boolean,
    location: Location,
    loading: boolean
  }> = this.params$.pipe(switchMap((params) =>
      this.select(this.store.select(selectStatusViewModel(params?.data?.id)),
          this.locationListLocalStore.loadingValues$,
          (statusViewModel, loadingValues) => ({
            ...statusViewModel, loading: loadingValues[params?.data?.id]?.[params?.colDef?.field]
          })
      )),
  );

}
